import { render, staticRenderFns } from "./CollectionWidgets.vue?vue&type=template&id=f95f00fe&scoped=true"
import script from "./CollectionWidgets.vue?vue&type=script&lang=js"
export * from "./CollectionWidgets.vue?vue&type=script&lang=js"
import style0 from "./CollectionWidgets.vue?vue&type=style&index=0&id=f95f00fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95f00fe",
  null
  
)

export default component.exports